/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import OrdersApi from '@/api/ordersV2';
import { OrdersV2 } from '@/api/ordersV2/types';
import { OrderStatusV2Enum } from '@/enums/orderV2';
import { Vue, Component, Prop } from 'vue-property-decorator';
import ApplyFailDetails from './components/apply-fail-details';
import ApplyProcessDetails from './components/apply-process-details';
import ApplySuccessDetails from './components/apply-success-details';

const style = require('./index.module.scss');

@Component({ name: 'ApplyDetails' })
export default class ApplyDetails extends Vue {
  // 提现申请apply接口直接返回失败的情况下，不存在orderId
  @Prop(String) readonly orderId!: string;

  @Prop(String) readonly commodityId!: string;

  private orderDetail: OrdersV2.OrderDetail | null = null;

  private commodityDetail: OrdersV2.CommodityDetail | null = null;

  // 业务申请订单状态映射
  private get applyStatus(): OrderStatusV2Enum | undefined {
    if (!this.orderId || this.orderId === 'undefined') {
      return OrderStatusV2Enum.LEND_FAILED;
    }

    if (this.orderDetail) {
      if (
        [
          OrderStatusV2Enum.LENDING,
          OrderStatusV2Enum.SIGNING,
          OrderStatusV2Enum.SIGNED,
          OrderStatusV2Enum.SIGN_FAILED,
          OrderStatusV2Enum.SUBMITTING,
          OrderStatusV2Enum.SUBMITTED,
        ].indexOf(this.orderDetail.state) >= 0
      ) {
        return OrderStatusV2Enum.LENDING;
      }
      if (
        [
          OrderStatusV2Enum.REJECTED,
          OrderStatusV2Enum.CANCELLED,
          OrderStatusV2Enum.LEND_FAILED,
        ].indexOf(this.orderDetail.state) >= 0
      ) {
        return OrderStatusV2Enum.LEND_FAILED;
      }

      return this.orderDetail.state;
    }

    return undefined;
  }

  private created() {
    if (this.orderId) {
      this.startPolling();
    }
  }

  private async startPolling() {
    await this.getApplyResult();

    switch (this.applyStatus) {
      case OrderStatusV2Enum.LENDING:
        this.$ubtPageButton('finance_withDrawDetails_applying');
        break;

      case OrderStatusV2Enum.LENT:
      case OrderStatusV2Enum.PAYOFF:
        this.$ubtPageButton('finance_withDrawDetails_successful');
        break;

      case OrderStatusV2Enum.LEND_FAILED:
        this.$ubtPageButton('finance_withDrawDetails_failed');
        break;

      default:
        break;
    }
  }

  // 获取查询结果
  private async getApplyResult() {
    const { loanOrderVo, commodityDetailVO } = await OrdersApi.queryOrder(
      this.orderId,
    );
    this.orderDetail = loanOrderVo;
    this.commodityDetail = commodityDetailVO;
  }

  // 获取订单状态是否为LENT&PAYOFF状态
  private get isLentOrPayoff() {
    return this.applyStatus === OrderStatusV2Enum.LENT
      || this.applyStatus === OrderStatusV2Enum.PAYOFF;
  }

  private render() {
    return (
      <div class={style.ApplyDetails}>
        {this.applyStatus === OrderStatusV2Enum.LENDING && (
          <ApplyProcessDetails
            orderDetail={this.orderDetail}
            commodityDetail={this.commodityDetail}
          />
        )}
        {this.isLentOrPayoff && (
          <ApplySuccessDetails
            orderDetail={this.orderDetail}
            commodityDetail={this.commodityDetail}
            isLentOrPayoff={this.isLentOrPayoff}
          />
        )}
        {this.applyStatus === OrderStatusV2Enum.LEND_FAILED && (
          <ApplyFailDetails
            orderDetail={this.orderDetail}
            commodityDetail={this.commodityDetail}
          />
        )}
      </div>
    );
  }
}
